import { useLocation } from 'react-router-dom';
import { ActiveMicrobesContainer } from '@screens/ActiveMicrobes/ActiveMicrobesContainer';
import { useGetMyActiveMicrobes } from '@viome/viome-base/src/usecase/Health/HealthQuery';
import { getQueryParam } from '@/utils/getQueryParam';

export const ActiveMicrobesPage = () => {
  const location = useLocation();
  const type = getQueryParam('type', location.search) || 'gut';
  const { data, isLoading, isError } = useGetMyActiveMicrobes(type);

  if (isError) {
    return (
      <div className="dark bg-black h-full w-full flex justify-center items-center">
        <p className="typography-body text-primary">
          Failed to load data. Please try again.
        </p>
      </div>
    );
  }

  return (
    <div className="dark bg-black h-full w-full">
      <ActiveMicrobesContainer
        activeMicrobes={data}
        isLoading={isLoading || !data}
      />
    </div>
  );
};
